module.exports = "<!-- <img [src]=\"offerta.LinkFoto\">\r\n  <a [routerLink]=\"['/Offerta',offerta.Id_Offerta]\"> Scopri</a> -->\r\n<a [routerLink]=\"['/Offerta',offerta.Id_Offerta]\">\r\n<img [src]=\"offerta.LinkFoto\" [alt]=\"offerta.NomeOfferta\"></a> "


//////////////////
// WEBPACK FOOTER
// ./src/app/offerta-min-foto/offerta-min-foto.component.html
// module id = ./src/app/offerta-min-foto/offerta-min-foto.component.html
// module chunks = main